import React, { useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { format, parseISO } from 'date-fns';
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from '@material-ui/pickers';
import {
  Button,
  Collapse,
  Divider,
  Icon,
  IconButton,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Chip,
  Typography
} from '@material-ui/core';
import { subscriptionStatus } from 'helpers/customerSubscriptions';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';


const FilterDrawer = ({setOpenFilter, setFilterConditions, filterConditions}) => {
  const [expandedStatus, toggleExpandedStatus] = useState(false);
  const [expandedCreated, toggleExpandedCreated] = useState(false);
  const [expandedLastRun, toggleExpandedLastRun] = useState(false);
  const [expandedNextRun, toggleExpandedNextRun] = useState(false);
  const [conditions, setConditions] = useState({
    created_from: {
      field: 'created_at',
      value: filterConditions.created_from?.value || '',
      conditionType: 'gt'
    },
    created_to: {
      field: 'created_at',
      value: filterConditions.created_to?.value || '',
      conditionType: 'lt'
    },
    last_run_from: {
      field: 'last_run',
      value: filterConditions.last_run_from?.value || '',
      conditionType: 'gt'
    },
    last_run_to: {
      field: 'last_run',
      value: filterConditions.last_run_to?.value || '',
      conditionType: 'lt'
    },
    next_run_from: {
      field: 'next_run',
      value: filterConditions.next_run_from?.value || '',
      conditionType: 'gt'
    },
    next_run_to: {
      field: 'next_run',
      value: filterConditions.next_run_to?.value || '',
      conditionType: 'lt'
    },
    status: {
      field: 'status',
      value: filterConditions.status?.value || '',
      conditionType: 'eq'
    },
  });

  const setConvertedDate = (value) => {
    const date = new Date(value);
    return date.toUTCString();
  };

  const handleClearDate = (event, name) => {
    event.preventDefault();
    event.stopPropagation();
    setConditions({
      ...conditions,
      [name]: {
        ...conditions['created_from'],
        value: ''
      }
    });
  };

  const handleChangeFilter = (field, value, conditionType, name) => {
    setConditions((conditions) => (
      {
        ...conditions,
        [name]: {
          field,
          value,
          conditionType
        }
      }
    ));
  };

  const handleApplyFilter = () => {
    setFilterConditions(conditions);
    setOpenFilter(false);
  };

  const isCreateAtError = conditions?.created_to.value !== '' && conditions?.created_to.value < conditions?.created_from?.value;
  const isLastRunError = conditions?.last_run_to.value !== '' && conditions?.last_run_to.value < conditions?.last_run_from?.value;
  const isNextRunError = conditions?.next_run_to.value !== '' && conditions?.next_run_to.value < conditions?.next_run_from?.value;
  const isFilterError = isCreateAtError || isLastRunError || isNextRunError;

  return (
    <div className="px-4 pt-4 min-h-full-screen flex-column justify-between">
      <div>
        <div className="flex items-center justify-between mb-2">
          <Typography variant="h5" className="text-primary uppercase">Filter by:</Typography>
          <IconButton onClick={() => setOpenFilter(false)}>
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </div>
        <div className="flex items-center flex-wrap mb-2">
          {Object.values(conditions).map((filterItem, index) => {
            if (!filterItem.value) {
              return null;
            }

            let label = filterItem.value;
            const fieldName = Object.keys(conditions)[index];

            if (filterItem.field === 'created_at' && filterItem.conditionType === 'gt') {
              label =  `Purchase From: ${format(parseISO(filterItem.value.replace(/%/g, '')), 'MM/dd/yyyy')}`;
            }

            if (filterItem.field === 'created_at' && filterItem.conditionType === 'lt') {
              label =  `Purchase To: ${format(parseISO(filterItem.value.replace(/%/g, '')), 'MM/dd/yyyy')}`;
            }

            if (filterItem.field === 'last_run' && filterItem.conditionType === 'gt') {
              label =  `Last Run From: ${format(parseISO(filterItem.value.replace(/%/g, '')), 'MM/dd/yyyy')}`;
            }

            if (filterItem.field === 'last_run' && filterItem.conditionType === 'lt') {
              label =  `Last Run To: ${format(parseISO(filterItem.value.replace(/%/g, '')), 'MM/dd/yyyy')}`;
            }

            if (filterItem.field === 'next_run' && filterItem.conditionType === 'gt') {
              label =  `Next Run From: ${format(parseISO(filterItem.value.replace(/%/g, '')), 'MM/dd/yyyy')}`;
            }

            if (filterItem.field === 'next_run' && filterItem.conditionType === 'lt') {
              label =  `Next Run To: ${format(parseISO(filterItem.value.replace(/%/g, '')), 'MM/dd/yyyy')}`;
            }

            if (filterItem.field === 'status') {
              label =  subscriptionStatus[filterItem.value];
            }

            return (
              <div key={`filter-${index}`} className="mr-2 mb-2">
                <Chip
                  label={label}
                  onDelete={() => {
                    setConditions({
                      ...conditions,
                      [fieldName]: {
                        ...conditions[fieldName],
                        value: ''
                      }
                    });
                  }}
                />
              </div>
            );
          })}
        </div>
        <div>
          <Divider className="my-5" />
          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => toggleExpandedStatus((expandedStatus) => !expandedStatus)}
          >
            <Typography variant="h6">Status</Typography>
            {expandedStatus ? <ExpandLess /> : <ExpandMore />}
          </div>
          <Collapse in={expandedStatus} timeout="auto">
            <FormControl component="div">
              <RadioGroup
                aria-label="status"
                name="status"
                value={conditions?.status?.value || ''}
                onChange={({target: {value, name}}) => handleChangeFilter(name, value, 'eq', name)}
              >
                {Object.keys(subscriptionStatus).map((status) => (
                  <FormControlLabel
                    key={`order-status-${status}`}
                    value={status}
                    control={<Radio color="primary" size="small" />}
                    label={subscriptionStatus[status]}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Collapse>
          <Divider className="my-5" />
          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => toggleExpandedCreated((expandedDate) => !expandedDate)}
          >
            <Typography variant="h6">Purchase Date</Typography>
            {expandedCreated ? <ExpandLess /> : <ExpandMore />}
          </div>
          <Collapse in={expandedCreated} timeout="auto">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                disableFuture
                autoOk
                fullWidth
                variant="inline"
                format="MM/dd/yyyy"
                emptyLabel="mm/dd/yyyy"
                name="created_from"
                label="From"
                className="mt-5"
                value={
                  conditions?.created_from?.value
                    ? setConvertedDate(conditions.created_from.value)
                    : null
                }
                onChange={(date) => handleChangeFilter(
                  'created_at',
                  `${format(date, 'yyyy-MM-dd 00:00:00')}`,
                  'gt',
                  'created_from'
                )
                }
                inputVariant="outlined"
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <CalendarTodayIcon className="text-muted text-16" />
                  ),
                  endAdornment: (
                    <Icon
                      className="cursor-pointer"
                      onClick={(event) => handleClearDate(event, 'created_from')}
                    >
                      close
                    </Icon>
                  )
                }}
                error={isCreateAtError}
                helperText={
                  isCreateAtError
                  && '"From" Date can not be later than "To" Date'
                }
              />
              <DatePicker
                autoOk
                fullWidth
                variant="inline"
                format="MM/dd/yyyy"
                emptyLabel="mm/dd/yyyy"
                name="created_to"
                className="mt-5"
                label="To"
                value={
                  conditions?.created_to?.value
                    ? setConvertedDate(conditions.created_to.value)
                    : null
                }
                onChange={(date) => handleChangeFilter(
                  'created_at',
                  `${format(date, 'yyyy-MM-dd 23:59:59')}`,
                  'lt',
                  'created_to'
                )
                }
                inputVariant="outlined"
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <CalendarTodayIcon className="text-muted text-16" />
                  ),
                  endAdornment: (
                    <Icon
                      className="cursor-pointer"
                      onClick={(event) => handleClearDate(event, 'created_to')}
                    >
                      close
                    </Icon>
                  )
                }}
              />
            </MuiPickersUtilsProvider>
          </Collapse>
          <Divider className="my-5" />
          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => toggleExpandedLastRun((expandedLastRun) => !expandedLastRun)}
          >
            <Typography variant="h6">Last Run</Typography>
            {expandedLastRun ? <ExpandLess /> : <ExpandMore />}
          </div>
          <Collapse in={expandedLastRun} timeout="auto">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                disableFuture
                autoOk
                fullWidth
                variant="inline"
                format="MM/dd/yyyy"
                emptyLabel="mm/dd/yyyy"
                name="last_run_from"
                label="From"
                className="mt-5"
                value={
                  conditions?.last_run_from?.value
                    ? setConvertedDate(conditions.last_run_from.value)
                    : null
                }
                onChange={(date) => handleChangeFilter(
                  'last_run',
                  `${format(date, 'yyyy-MM-dd 00:00:00')}`,
                  'gt',
                  'last_run_from'
                )
                }
                inputVariant="outlined"
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <CalendarTodayIcon className="text-muted text-16" />
                  ),
                  endAdornment: (
                    <Icon
                      className="cursor-pointer"
                      onClick={(event) => handleClearDate(event, 'last_run_from')}
                    >
                      close
                    </Icon>
                  )
                }}
                error={isLastRunError}
                helperText={
                  isLastRunError
                  && '"From" Date can not be later than "To" Date'
                }
              />
              <DatePicker
                autoOk
                fullWidth
                variant="inline"
                format="MM/dd/yyyy"
                emptyLabel="mm/dd/yyyy"
                name="last_run_to"
                className="mt-5"
                label="To"
                value={
                  conditions?.last_run_to?.value
                    ? setConvertedDate(conditions.last_run_to.value)
                    : null
                }
                onChange={(date) => handleChangeFilter(
                  'last_run',
                  `${format(date, 'yyyy-MM-dd 23:59:59')}`,
                  'lt',
                  'last_run_to'
                )
                }
                inputVariant="outlined"
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <CalendarTodayIcon className="text-muted text-16" />
                  ),
                  endAdornment: (
                    <Icon
                      className="cursor-pointer"
                      onClick={(event) => handleClearDate(event, 'last_run_to')}
                    >
                      close
                    </Icon>
                  )
                }}
              />
            </MuiPickersUtilsProvider>
          </Collapse>
          <Divider className="my-5" />
          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => toggleExpandedNextRun((expandedNextRun) => !expandedNextRun)}
          >
            <Typography variant="h6">Next Run</Typography>
            {expandedNextRun ? <ExpandLess /> : <ExpandMore />}
          </div>
          <Collapse in={expandedNextRun} timeout="auto">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                autoOk
                fullWidth
                variant="inline"
                format="MM/dd/yyyy"
                emptyLabel="mm/dd/yyyy"
                name="next_run_from"
                label="From"
                className="mt-5"
                value={
                  conditions?.next_run_from?.value
                    ? setConvertedDate(conditions.next_run_from.value)
                    : null
                }
                onChange={(date) => handleChangeFilter(
                  'next_run',
                  `${format(date, 'yyyy-MM-dd 00:00:00')}`,
                  'gt',
                  'next_run_from'
                )
                }
                inputVariant="outlined"
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <CalendarTodayIcon className="text-muted text-16" />
                  ),
                  endAdornment: (
                    <Icon
                      className="cursor-pointer"
                      onClick={(event) => handleClearDate(event, 'next_run_from')}
                    >
                      close
                    </Icon>
                  )
                }}
                error={isNextRunError}
                helperText={
                  isNextRunError
                  && '"From" Date can not be later than "To" Date'
                }
              />
              <DatePicker
                autoOk
                fullWidth
                variant="inline"
                format="MM/dd/yyyy"
                emptyLabel="mm/dd/yyyy"
                name="next_run_to"
                className="mt-5"
                label="To"
                value={
                  conditions?.next_run_to?.value
                    ? setConvertedDate(conditions.next_run_to.value)
                    : null
                }
                onChange={(date) => handleChangeFilter(
                  'next_run',
                  `${format(date, 'yyyy-MM-dd 23:59:59')}`,
                  'lt',
                  'next_run_to'
                )
                }
                inputVariant="outlined"
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <CalendarTodayIcon className="text-muted text-16" />
                  ),
                  endAdornment: (
                    <Icon
                      className="cursor-pointer"
                      onClick={(event) => handleClearDate(event, 'next_run_to')}
                    >
                      close
                    </Icon>
                  )
                }}
              />
            </MuiPickersUtilsProvider>
          </Collapse>
          <Divider className="my-5" />
        </div>
      </div>
      <div className="flex items-center justify-between pb-4">
        <Button
          variant="contained"
          color="primary"
          fullWidth
          className="mr-2 uppercase"
          onClick={handleApplyFilter}
          disabled={isFilterError}
        >
          Apply Filters
        </Button>
        <Button
          variant="outlined"
          fullWidth
          className="uppercase"
          onClick={() => {
            setFilterConditions({});
            setOpenFilter(false);
          }}
        >
          Reset
        </Button>
      </div>
    </div>
  );
};

export default FilterDrawer;
